import { type ICheckListItem } from "src/interfaces";

export const checkBaseField = (item: ICheckListItem): 1 | 0 => {
  if (item.unit === "check") {
    if (item.value || item.notAvailable) {
      return 1;
    }
  } else if (item.unit === "text") {
    if (
      (item.value &&
        typeof item.value === "string" &&
        item.value.trim().length > 0) ||
      item.notAvailable
    ) {
      return 1;
    }
  } else if (item.unit === "date" || item.unit === "datetime") {
    if (item.value && !isNaN(new Date(item.value).getTime())) {
      return 1;
    }
  } else if (item.unit === "multiple") {
    if (Array.isArray(item.fields) && item.fields.length > 0)
      return item.fields.every(subItem => checkBaseField(subItem)) ? 1 : 0;
  }
  return 0;
};

/**
 * Calculates the progress of a checklist by counting the total and checked items.
 *
 * @param list - An array of checklist items (`ICheckListItem`) or undefined.
 * @returns A string representing the progress in the format "checked/total".
 */
export const getCheckListProgress = (list: ICheckListItem[] | undefined) => {
  if (!list) return "";
  let all = 0;
  let checked = 0;

  const validInputs = ["check", "text", "date", "datetime", "multiple"];
  for (const item of list) {
    if (validInputs.includes(item.unit)) {
      all++;
      checked += checkBaseField(item);
    }
  }

  return `${checked}/${all}`;
};
